import React, {Component} from 'react';

export class SignatureABRM extends Component {


    render() {
     const {state, copyBoxRef} = this.props;

    return (
        <div style={{fontSize: 10+'pt', fontFamily: 'arial, sans-serif'}} className="copyBox" ref={copyBoxRef}>
        <table style={{width:525+'px', fontSize:10+'pt', fontFamily:'Arial, sans-serif'}} cellPadding="0" cellSpacing="0">
          <tbody>
          <tr>

            <td style={{fontSize:16+'px', fontFamily:'Arial, sans-serif', color:'#0e1a29', width:326+'px', paddingBottom:5+'px', paddingLeft:10+'px', verticalAlign:'top'}}
                valign="top">
              <strong><span style={{fontSize:16+'px', color:'#0e1a29'}}><span
                  style={{fontFamily:'Arial, sans-serif', color:'#0e1a29'}}>{state.name}</span></span></strong><br/>
              <span
                  style={{fontFamily:'Arial, sans-serif', fontSize:14+'px', color:'#0e1a29'}}>{state.jobTitle}</span>
            </td>
          </tr>

          <tr>
            <td style={{fontSize:10+'pt', fontFamily:'Arial, sans-serif', color:'#8c8c8c', width:326+'px', paddingBottom:5+'px', paddingLeft:10+'px', verticalAlign:'top'}}
                valign="top">
                   <span style={{fontFamily:'Arial, sans-serif', fontSize:10+'pt', color:'#0e1a29'}}>
                       <img border="0" width="23"
                            alt="phone icon"
                            style={{border:0, height:23+'px', width:23+'px', marginRight: 15+'px'}}
                            src="https://img-static.emmerson.pl/signature/abrm/icon-phone.png"
                       />{state.cellphone}{state.phone && <span>, {state.phone}</span>}</span>
              <br/>
                <span
                    style={{fontFamily:'Arial, sans-serif', fontSize:10+'pt', color:'#0e1a29'}}>
                    <img border="0" width="23"
                         alt="email icon"
                         style={{border:0, height:23+'px', width:23+'px', marginRight: 15+'px'}}
                         src="https://img-static.emmerson.pl/signature/abrm/icon-email.png"
                    />{state.mail}<br/></span>
                <span style={{fontFamily:'Arial, sans-serif', fontSize:10+'pt', color:'#0e1a29'}}>
                    <img border="0" width="23"
                         alt="address icon"
                         style={{border:0, height:23+'px', width:23+'px', marginRight: 15+'px'}}
                         src="https://img-static.emmerson.pl/signature/abrm/icon-address.png"
                    />ul. Przy Bażantarni 11,<br/></span>
                <span style={{fontFamily:'Arial, sans-serif', fontSize:10+'pt', color:'#0e1a29', paddingLeft: 38+'px'}}>02-793 Warszawa</span>
            </td>
              <td style={{fontSize: 10+'pt',width: 199+'px', paddingRight: 10+'px', verticalAlign: 'top', textAlign: 'center'}}
                  valign="top" rowSpan="3" align="center">
                  <a href="http://abrm.pl" target="_blank" rel="noopener">
                      <img border="0" alt="logo" height="93" width="67"
                           style={{width: 67+'px', height:93+'px', border:0, maxHeight: 93+'px'}}
                           src="https://img-static.emmerson.pl/signature/abrm/abrm.png"/>
                  </a><br/>
                  <span>
                    <a href="https://www.facebook.com/Akademia-Badmintona-Roberta-Mateusiaka-557879320983145" target="_blank" rel="noopener">
                        <img border="0" width="23"
                             alt="facebook icon"
                             style={{border:0, height:23+'px', width:23+'px'}}
                             src="https://img-static.emmerson.pl/signature/abrm/fb.png"
                        />
                    </a>&nbsp;
                </span>
                  <span>
                    <a href="https://www.instagram.com/abrm_warszawa/" target="_blank" rel="noopener">
                        <img border="0" width="23"
                             alt="instagram icon"
                             style={{border:0, height:23+'px', width:23+'px'}}
                             src="https://img-static.emmerson.pl/signature/abrm/it.png"
                        />
                    </a>&nbsp;
                </span>
              </td>
          </tr>
          <tr>
            <td style={{fontSize:10+'pt', fontFamily:'Arial, sans-serif', color:'#8c8c8c', width:326+'px', paddingBottom:5+'px', paddingLeft:10+'px', verticalAlign:'middle'}}
                valign="middle">
              <span>
                  <strong>
                      <img border="0" width="23"
                           alt="link icon"
                           style={{border:0, height:23+'px', width:23+'px', marginRight: 15+'px'}}
                           src="https://img-static.emmerson.pl/signature/abrm/icon-link.png"
                      /><a href="http://abrm.pl" target="_blank" rel="noopener"
                               style={{textDecoration:'none'}}><span
                  style={{fontFamily:'Arial, sans-serif', fontSize:10+'pt', color:'#0e1a29'}}>www.abrm.pl</span></a></strong>
              </span>
            </td>
          </tr>

          <tr>
            <td colSpan='2'>
              <span>
                  <img border="0" width="525"
                       alt="banner"
                       style={{border:0, width:525+'px'}}
                       src="https://img-static.emmerson.pl/signature/abrm/bottom.png"
                  />
              </span>
            </td>
          </tr>

          <tr>
            <td style={{fontSize:10+'pt', fontFamily:'Arial, sans-serif', color:'#2a2a2a', paddingTop:10+'px', textAlign:'justify', verticalAlign:'top'}}
                align="justify" valign="top" colSpan="2">
   <span style={{fontFamily:'Arial, sans-serif', fontSize:10+'pt', color:'#999999'}}>Zanim wydrukujesz tę wiadomość pomyśl o środowisku.<br/><br/>
       ABRM Sp z o.o, adres: ul. Przy Bażantarni 11, 02-793 Warszawa, NIP 8942987111 Regon 021105553, KRS 0000340801, tel + 48 882 871 414, email abrm@abrm.pl, www.abrm.pl
</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/Components/SignatureABRM.js